module.exports = __webpack_public_path__ + "img/Flag_of_the_United_Kingdom_(3-5).127329b4.svg";